<div class="ss-modal">

  <header class="ss-head">
    <span class="ss-icon"><i class="fas fa-layer-group"></i></span>
    <div class="ss-head-text">
      <h2>{{ headingText }}</h2>
      <p>{{ subheadingText }}</p>
    </div>
    <button class="ss-close" type="button" aria-label="Close" (click)="onCancel()">
      <i class="fas fa-times"></i>
    </button>
  </header>

  <ion-searchbar
    class="ss-search"
    placeholder="Search"
    (ionClear)="handleClearSearch()"
    (ionChange)="handleSearchChange()"
    [(ngModel)]="searchItem">
  </ion-searchbar>

  <div class="options-list">
    <ion-list lines="none">
      <ng-container *ngFor="let section of sections">
        <div class="option-group" *ngIf="section.label">{{ section.label }}</div>
        <ion-item
          *ngFor="let option of section.options"
          [class.is-on]="isSelectedOption(option)">
          <ion-checkbox
            [checked]="isSelectedOption(option)"
            (ionChange)="handleCheckboxSelect($event.detail.checked, option)"
            class="select-checkbox"
            slot="start">
          </ion-checkbox>
          <ion-label class="option-text">{{ option }}</ion-label>
        </ion-item>
      </ng-container>
    </ion-list>
    <p class="no-options" *ngIf="hasNoMatches">No matches for &ldquo;{{ searchItem }}&rdquo;</p>
  </div>

  <div class="ss-foot">
    <button type="button" class="ss-btn ss-btn-ghost" (click)="onCancel()">Cancel</button>
    <button type="button" class="ss-btn ss-btn-primary" (click)="onSelect(selectedOptions)">Select</button>
  </div>

</div>
